module.exports = __webpack_public_path__ + "static/vista-8-a9425eaa030f0f601429d9a630dfa04a.jpeg";